import React from "react";
import './HV.css'

function HighVoltage() {
    return (
        <div className="high-voltage">
                <span>
                    <h5>Visokonaponska mreža</h5>
                </span>
        </div>
    );
}

export default HighVoltage;
